import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import { getApiBase } from '../../lib/apiBase';


const API = getApiBase();

export const VerifyEmail = () => {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [status, setStatus] = useState('loading'); // loading | success | already | error

  useEffect(() => {
    if (!token) { setStatus('error'); return; }

    const verify = async () => {
      try {
        const res = await fetch(`${API}/api/auth/verify-email`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        });
        const data = await res.json();
        if (res.ok) {
          setStatus(data.already_verified ? 'already' : 'success');
        } else {
          setStatus('error');
        }
      } catch {
        setStatus('error');
      }
    };
    verify();
  }, [token]);

  return (
    <div className="min-h-screen pt-20 pb-12 flex items-center justify-center px-4" style={{ background: '#0A0A0A' }}>
      <Card className="w-full max-w-md text-center" style={{ background: '#141414', border: '1px solid rgba(255,255,255,0.1)' }}>
        <CardHeader>
          {status === 'loading' && (
            <>
              <div className="mx-auto mb-4"><Loader2 className="w-10 h-10 text-emerald-400 animate-spin" /></div>
              <CardTitle className="text-xl text-white" data-testid="verify-loading">Verifying your email...</CardTitle>
            </>
          )}
          {(status === 'success' || status === 'already') && (
            <>
              <div className="mx-auto w-14 h-14 rounded-full flex items-center justify-center mb-4" style={{ background: 'rgba(16,185,129,0.15)' }}>
                <CheckCircle2 className="w-7 h-7 text-emerald-400" />
              </div>
              <CardTitle className="text-xl text-white" data-testid="verify-success-heading">
                Email Verified!
              </CardTitle>
              <p className="text-sm text-gray-400 mt-2" data-testid="verify-success-desc">
                {status === 'already'
                  ? 'Your email was already verified. You can sign in below.'
                  : 'Your email has been verified. You can now sign in to your account.'}
              </p>
            </>
          )}
          {status === 'error' && (
            <>
              <div className="mx-auto w-14 h-14 rounded-full flex items-center justify-center mb-4" style={{ background: 'rgba(239,68,68,0.15)' }}>
                <XCircle className="w-7 h-7 text-red-400" />
              </div>
              <CardTitle className="text-xl text-white" data-testid="verify-failed-heading">
                Verification Failed
              </CardTitle>
              <p className="text-sm text-gray-400 mt-2" data-testid="verify-failed-desc">
                This verification link is invalid or has expired. Please try registering again.
              </p>
            </>
          )}
        </CardHeader>
        <CardContent>
          {(status === 'success' || status === 'already') && (
            <Link to="/auth/login" data-testid="verify-login-cta">
              <Button className="w-full bg-emerald-600 hover:bg-emerald-700 text-white">
                Sign In
              </Button>
            </Link>
          )}
          {status === 'error' && (
            <Link to="/auth/register" data-testid="verify-register-cta">
              <Button className="w-full bg-white/10 hover:bg-white/15 text-white">
                Back to Registration
              </Button>
            </Link>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
